import { render, staticRenderFns } from "./backup-history.component.vue?vue&type=template&id=419c4344"
import script from "./backup-history.component.ts?vue&type=script&lang=ts&external"
export * from "./backup-history.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports